import $ from 'jquery';
import nav from './nav';
const posts = {

	insertPosts: function (content, block, blockData) {
		blockData.postsWrapper.insertAdjacentHTML( 'beforeend', content );
		const currentPosts = block.querySelectorAll( '.loadmore-item:not(.slider-item)' );
		if (currentPosts.length == blockData.allPostsCount) {
			console.log( blockData.button );
			blockData.button.style.display = 'none';
		}
		if (block.classList.contains( 'faq-block' )) {
			nav.refreshFaqAccordion( blockData.loadCount );
		}

	},

	loadMorePosts: function (block, blockData, action) {
		const currentIds = [];
		const instance   = this;
		block.querySelectorAll( '.loadmore-item' ).forEach(
			post => {
            currentIds.push( post.getAttribute( 'data-post-id' ) );
			}
		);
		const data = {
			'action': action,
			'paged': blockData.loadCount,
			'postsNotIn': currentIds,
			'categoryIn': blockData.categories,
		};
		fetch(
			ajax_url,
			{
				method: 'POST',
				body: new URLSearchParams(
					{
						...data
					}
				)
			}
		)
			.then( response => response.text() )
			.then(
				response => {
                instance.insertPosts( response, block, blockData );
				}
			)
			.catch( err => console.log( err ) );
	},

	postsListBlock: function (block) {
		const button    = block.querySelector( '.js-load-more-posts' );
		const blockData = {
			postsWrapper: block.querySelector( '.js-loadmore-wrapper' ),
			categories: block.getAttribute( 'data-categories' ),
			loadCount: block.getAttribute( 'data-load-count' ),
			allPostsCount: block.getAttribute( 'data-all-posts-count' ),
			button: block.querySelector( '.js-load-more-posts' ),
		};

		if ( ! button) {
			return;
		}
		const action   = 'load-more-posts';
		const instance = this;
		button.addEventListener(
			'click',
			function () {
				instance.loadMorePosts( block, blockData, action );
			}
		);
	},
	faqListBlock: function (block) {
		const button    = block.querySelector( '.js-load-more-posts' );
		const blockData = {
			postsWrapper: block.querySelector( '.js-loadmore-wrapper' ),
			categories: block.getAttribute( 'data-categories' ),
			loadCount: block.getAttribute( 'data-load-count' ),
			allPostsCount: block.getAttribute( 'data-all-posts-count' ),
			button: block.querySelector( '.js-load-more-posts' ),
		};

		if ( ! button) {
			return;
		}
		const action   = 'load-more-faq';
		const instance = this;
		button.addEventListener(
			'click',
			function () {
				instance.loadMorePosts( block, blockData, action );
			}
		);
	},

	loadMoreResults: function() {
		$( '.search-results__wraper-result' ).on(
			'click',
			'#load-more-results',
			function(e) {
				e.preventDefault();

				let ppp     = parseInt( $( '#filter_results' ).attr( 'data-ppp' ) ),
					order   = $( '#filter_results' ).attr( 'data-order' ),
					orderby = $( '#filter_results' ).attr( 'data-orderby' ),
					search  = $( '.search-box__search-input' ).val();

				ppp = ppp + 10;

				$.ajax(
					{
						method: "POST",
						url: search_filter.ajaxurl,
						data: {
							'action' : 'search_filter',
							'order' : order,
							'orderby' : orderby,
							'search' : search,
							'ppp' : ppp,
						},
					}
				).done(
					function (data) {
						$( ".search-results__wraper-result" ).html( data );
						$( '#filter_results' ).attr( 'data-order',order )
						$( '#filter_results' ).attr( 'data-orderby',orderby )
						$( '#filter_results' ).attr( 'data-ppp',ppp )
					}
				);

			}
		);
	},

	init: function () {

		const postsBlocks = document.querySelectorAll( '.posts-list-block' );
		if (postsBlocks) {
			postsBlocks.forEach(
				block => {
                this.postsListBlock( block );
				}
			);

		}
		const faqBlocks = document.querySelectorAll( '.faq-block' );
		if (faqBlocks) {
			faqBlocks.forEach(
				block => {
                this.faqListBlock( block );
				}
			);

		}

	},
}
export default posts;
